import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { BreadcrumbService } from 'src/app/shared/service/breadcrumb.service';
import { RsaService } from 'src/app/shared/service/rsa.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public baseUrl = environment.apiBaseUrl + '/users';
  public user;

  constructor(private http: HttpClient, private rsaService: RsaService, private breadcrumbService: BreadcrumbService) { }

  getEmail(email) {
    return this.http.post(`${this.baseUrl}`, email).pipe(tap(x => { this.setToken(x); }));
  }

  switchPortalContext(switchPortalContext) {
    return this.http.get(`${this.baseUrl}/switchPortalContext`, {
      headers: {Authorization: `Bearer ${switchPortalContext}`}
    }).pipe(tap(x => this.setToken(x)));
  }

  activateAccount(data) {
    return this.http.post(`${this.baseUrl}/account`, data);
  }

  generateRandomPasswordWithEmail(data) {
    return this.http.post(`${this.baseUrl}/register`, data);
  }

  setToken(data) {
    if (data.token) {
      console.log('datta', data);
      const token = data.token;
      this.user = data.user;
      let USERACCESS = [];
      localStorage.clear();
      try {
        USERACCESS =
          Array.isArray(data.user.USERACCESSES.USERACCESS)
            ? data.user.USERACCESSES.USERACCESS : [data.user.USERACCESSES.USERACCESS];
        localStorage.setItem('1', token);
        localStorage.setItem('2', this.rsaService.encrypt(JSON.stringify(this.user)));
        localStorage.setItem('USERACCESS', this.rsaService.encrypt(JSON.stringify(USERACCESS)));
        localStorage.setItem('3', this.rsaService.encrypt(data.user.USER.MAIL_ID));
        localStorage.setItem('4', this.rsaService.encrypt(data.user.USER.USER_NAME));
        localStorage.setItem('5', this.rsaService.encrypt(data.user.USER.NO_OF_PARTIES));
        localStorage.setItem('6', this.rsaService.encrypt(data.user.USER.USER_TYPE));
        localStorage.setItem('7', this.rsaService.encrypt(data.user.USER.ALLOW_PORTAL_SWITCH));
        this.breadcrumbService.setSelectValues(USERACCESS, data.user.USER.NO_OF_PARTIES || 0);
      } catch (error) {
        console.log('Error occurred', error);
        localStorage.clear();
      }
    }
  }

  isFirstLogin() {
    try {
      const FIRST_LOGIN_FLAG = JSON.parse(this.rsaService.decrypt(localStorage.getItem('2'))).USER.FIRST_LOGIN_FLAG;
      return FIRST_LOGIN_FLAG === 'Y';
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  getUserType() {
    return this.rsaService.decrypt(localStorage.getItem("6"));
  }

  getUser() {
    return JSON.parse(this.rsaService.decrypt(localStorage.getItem("2")));
  }

  logout() {
    localStorage.clear();
  }

  tokenVerfiy() {
    return this.http.get(`${this.baseUrl}/tokenVerfiy`);
  }

  FileUpload(files) {
    return this.http.post(`${this.baseUrl}/fileUpload`, files);
  }

  getHomeDetails(user) {
    return this.http.post(`${this.baseUrl}/homePage`, user);
  }

  getDashboardData(payload) {
    return this.http.post(`${this.baseUrl}/dashboard`, payload);
  }

  getNewsFeed() {
    let filter = environment.isMedisafe ? 'showInMedisafe=true' : 'showInYTY=true';
    //let filter = environment.isMedisafe ? '&showInMedisafe=true' : '&showInYTY=true';
    // return this.http.get(`${environment.cmsBaseUrl}/news-feeds?_sort=order${filter}`);
    return this.http.get(`${environment.cmsBaseUrl}/newsfeed.php?${filter}`);
  }

  getIndividualDashboardData(payload) {
    return this.http.post(`${this.baseUrl}/dashboard-data`, payload);
  }

  downloadAttachment() {
    return this.http.get(`${this.baseUrl}/user-manual`, {
      responseType: 'arraybuffer'
    })
  }

  sendPasswordResetLinktoEmail(payload) {
    return this.http.post(`${this.baseUrl}/forgot-password`, payload);
  }

  verifyJWTToken(payload) {
    return this.http.post(`${this.baseUrl}/verify-jwt`, payload);
  }

  changePassword(payload) {
    return this.http.post(`${this.baseUrl}/change-password`, payload);
  }

}
